export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_SYMBOLS = '!@#$%^§&*+-:;,.?_~'
